import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Reset default styles
const style = document.createElement('style');
style.textContent = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
  tr:hover { background: #f8f9ff !important; }
  input:focus, select:focus { border-color: #0f3460 !important; }
  button:hover { opacity: 0.9; }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
